<script lang="ts">
  export type GatKeyboardShortcutHintProps = Omit<
    GatKeyboardShortcutsProps,
    'class'
  > & {
    triggerClass?: HTMLAttributes['class']
    /** @default '-top-8 left-1/2 -translate-x-1/2' */
    shortcutClass?: HTMLAttributes['class']
    disabled?: boolean
    align?: 'bottom' | 'top'
  }

  /** #ASC */
</script>

<script setup lang="ts">
  import GatKeyboardShortcuts, {
    type GatKeyboardShortcutsProps
  } from './gat-keyboard-shortcuts.vue'
  import { computed, type HTMLAttributes } from 'vue'
  import { cn } from '@gat-ship/vue-components'

  defineOptions({
    inheritAttrs: false
  })

  const props = withDefaults(defineProps<GatKeyboardShortcutHintProps>(), {
    align: 'bottom'
  })

  const _shortcutClass = computed(() => {
    return cn(
      'pointer-events-none absolute select-none opacity-0 transition-opacity group-hover:opacity-100 w-fit min-w-fit whitespace-nowrap',
      {
        '-top-8 left-1/2 -translate-x-1/2': props.align === 'top',
        '-bottom-8 left-1/2 -translate-x-1/2': props.align === 'bottom',
        'pointer-events-none opacity-0 group-hover:opacity-0': props.disabled
      },
      props.shortcutClass
    )
  })
</script>
<template>
  <div :class="cn('group relative', props.triggerClass)">
    <slot />
    <gat-keyboard-shortcuts :shortcut="props.shortcut" :class="_shortcutClass">
      <slot name="shortcut" />
    </gat-keyboard-shortcuts>
  </div>
</template>
